function wordToKey(word: string): string {
  return [...word].sort().join('');
}

/**
 * Given a lexicon, creates an accelerator for looking up word letter jumble
 * solutions.
 */
export class Jumble {
  private readonly keyToWords = new Map<string, string[]>();

  constructor(words: string[]) {
    for (const word of words) {
      const key = wordToKey(word);
      let matchingWords = this.keyToWords.get(key);
      if (matchingWords === undefined) {
        matchingWords = [];
        this.keyToWords.set(key, matchingWords);
      }
      matchingWords.push(word);
    }
  }

  matches(word: string): string[] {
    const key = wordToKey(word);
    return this.keyToWords.get(key) || [];
  }
}
